import { apiClient } from './authService';

export async function getCustomerMediaBlobUrl(mediaPublicId) {
  const response = await apiClient.get(`/customer/workspace_media/serve/${mediaPublicId}`, {
    responseType: 'blob',
  });
  if (response.data instanceof Blob) {
    return window.URL.createObjectURL(response.data);
  }
  return null;
}

export async function downloadCustomerMedia(mediaPublicId, fileName) {
  const response = await apiClient.get(`/customer/workspace_media/serve/${mediaPublicId}`, {
    responseType: 'blob',
  });
  if (!(response.data instanceof Blob)) return false;
  const blobUrl = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = fileName || 'download';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
  return true;
}
